import { useCallback, useContext } from "react";
import useSWRMutation from "swr/mutation";
import { ChasableSignalRContext as SignalRContext } from "../context/ChasablesContext";
import { ToastContext } from "../context/ToastContext";
import { useTaskpaneTelemetry } from "../telemetry/useTaskpaneTelemetry";

export function useCompleteChasables() {
  const { showToast } = useContext(ToastContext);
  const { trackReceivableCompleteSucceeded, trackReceivableCompleteFailed } = useTaskpaneTelemetry();
  const { trigger, isMutating, error } = useSWRMutation(
    "CompleteExternals",
    (url, { arg }: { arg: string[] }) => SignalRContext.connection?.invoke<void>(url, arg, {}),
    {
      onError: () => {
        showToast("Failed to complete multiple invoices, please try again later", "error");
      },
      onSuccess: () => {
        showToast("Invoices marked as completed", "success");
      },
    }
  );

  const completeChasables = useCallback(
    async (invoiceIds: string[]) => {
      try {
        await trigger(invoiceIds);
        trackReceivableCompleteSucceeded({ invoice_count: String(invoiceIds.length) });
      } catch (e) {
        trackReceivableCompleteFailed({
          invoice_count: String(invoiceIds.length),
          error: e instanceof Error ? e.message : String(e),
        });
        throw e;
      }
    },
    [trackReceivableCompleteFailed, trackReceivableCompleteSucceeded, trigger]
  );

  return {
    completeChasables,
    isLoading: isMutating,
    isError: !!error,
  };
}
